import {
  NOTIFICATION_SUCCESS,
  NOTIFICATION_RESET,
  NOTIFICATION_ERROR,
  NOTIFICATION_LOADING
} from './constants'

export function notificationSuccess ({message}) {
  return {type: NOTIFICATION_SUCCESS, payload: {message}}
}

export function notificationError ({message}) {
  return {type: NOTIFICATION_ERROR, payload: {message}}
}

export function notificationReset () {
  return {type: NOTIFICATION_RESET, payload: {}}
}

export function notificationLoading ({loading}) {
  return {type: NOTIFICATION_LOADING, payload: {loading}}
}



// WEBPACK FOOTER //
// app/javascript/components/actions/notification/notification.js